import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { IPortfolioResultRequest, IPortfolioResultResponse, IHighLevelInfoDto } from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";

export abstract class EditorPortfolioResultService {
    abstract getPortfolioResult(request: Partial<IPortfolioResultRequest>): Observable<Partial<IPortfolioResultResponse>>;
}

@Injectable({
    providedIn: "root"
})
export class IrbEditorPortfolioResultService implements EditorPortfolioResultService {
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "Sat, 01 Jan 2000 00:00:00 GMT"
        })
    };

    constructor(private _http: HttpClient) {
    }

    getPortfolioResult(request: Partial<IPortfolioResultRequest>): Observable<Partial<IPortfolioResultResponse>> {
        return this._http.post<IPortfolioResultResponse>("/irebalone/portfolio-summary", request, this.httpOptions);
    }

    gethighLevelInfoDto(rebalPkgId: number): Observable<IHighLevelInfoDto> {
        return this._http.get<IHighLevelInfoDto>('/irebalone/rebalance/get-rebalance-result-details/' + rebalPkgId);
    }

    getPortfolioResultAsync(request: Partial<IPortfolioResultRequest>): Observable<Partial<IPortfolioResultResponse>> {
        return this._http.post<IPortfolioResultResponse>('/irebalone/portfolio-summary-async', request, this.httpOptions);
    }

    getActionStatusCheck(actionStatusId: any) {
        return this._http.get('/irebalone/rebal-pfr-summary-action-status/' + actionStatusId);
    }
}
